import { apiRequest } from './apiService';

// CRM Communications
export const fetchCrmCommunications = async () => {
  return await apiRequest('/crm/crm-communications', 'GET');
};

export const createCrmCommunication = async (communicationData: any) => {
  return await apiRequest('/crm/crm-communications', 'POST', communicationData);
};
export const updateCrmCommunication = async (
  communicationId: number,
  communicationData: any
) => {
  return await apiRequest(
    `/crm/crm-communications/${communicationId}`,
    'PUT',
    communicationData
  );
};
export const deleteCommunication = async (communicationId: string) => {
  return await apiRequest(
    `/crm/crm-communications/${communicationId}`,
    'DELETE'
  );
};
